import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import translations
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';

// Type-safe resources
const resources = {
  en: {
    all: enTranslations,
  },
  fr: {
    all: frTranslations,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS: 'all',
    fallbackNS: 'all',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
  });

export default i18n;
